import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { Component, HostListener, Inject, OnInit, PLATFORM_ID, Renderer2 } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { Router } from '@angular/router';

@Component({
  selector: 'app-website',
  templateUrl: './website.component.html',
  styleUrls: ['./website.component.css']
})
export class WebsiteComponent implements OnInit {
  scrolled = false;

  @HostListener('window:scroll', [])
  onWindowScroll() {
    this.scrolled = window.scrollY > 50; // adjust threshold
  }
  constructor(
    private titleService: Title, private metaService: Meta,@Inject(PLATFORM_ID) private platformId: Object,
    private renderer: Renderer2, @Inject(DOCUMENT) private document: Document, private router:Router
  ){}
  ShowCard:any;
showBox(data:any){
if(data == 1){
  if (this.ShowCard == 2) {
    this.ShowCard = ''
  } else {
this.ShowCard = 2
    
  }
}
if(data == 2){
  if (this.ShowCard == 1) {
    this.ShowCard = ''
  } else {
    this.ShowCard = 1

    
  }
  }
  if(data == 3){
    if (this.ShowCard == 3) {
      this.ShowCard = ''
    } else {
      this.ShowCard = 3
      
    }
   
    } 
}

ngOnInit() {
  if (isPlatformBrowser(this.platformId)) {
    setTimeout(() => {
      const dialog = document.getElementById('welcomeDialog');
      const closeBtn = document.getElementById('closeDialog');
      const closeX = document.getElementById('closeDialogX');

      if (!sessionStorage.getItem('dialogShown')) {
        dialog?.classList.add('active');
        sessionStorage.setItem('dialogShown', 'true');
      }

      const closeDialog = () => {
        dialog?.classList.remove('active');
      };

      closeX?.addEventListener('click', closeDialog);
      closeBtn?.addEventListener('click', () => {
        closeDialog();
      });

    }, 20000);
  }
}


// ngOnInit() {
  

//   setTimeout(()=>{
// const dialog = document.getElementById('welcomeDialog');
// const closeBtn = document.getElementById('closeDialog');   // Contact Us
// const closeX = document.getElementById('closeDialogX');    // X button

// if (!sessionStorage.getItem('dialogShown')) {
//   dialog?.classList.add('active');
//   sessionStorage.setItem('dialogShown', 'true');
// }

// const closeDialog = () => {
//   dialog?.classList.remove('active');
// };

// // Close when clicking X
// closeX?.addEventListener('click', closeDialog);

// // Close when clicking Contact Us (before navigation)
// closeBtn?.addEventListener('click', (event) => {
//   closeDialog();
// });

//   },20000)
  
// }

openLogin(){
  window.open('https://dev-merchant.facheck.biz/login')
}
openLink(link:any){
  location.href = `${link}`
}
 navigateWithTab(tab: string) {
  this.router.navigate(['/home'], {
    queryParams: { tab: tab }
  });
}
}